/**
 * Referrer data localStorage key
 */
export const REFERRER_STORAGE_KEY = 'zep_quiz_enter_referrer';

/**
 * TTL (Time To Live) - 5분
 * 5분 이내 데이터만 유효하다고 간주
 */
export const REFERRER_TTL_MS = 5 * 60 * 1000;

/**
 * Default fallback values
 */
export const DEFAULT_FROM = 'direct';
export const DEFAULT_LOCATION = undefined;
